import React from 'react';
import Textbox from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.ACCOUNT_NAME
};
export const AccountName = props => {
  var _a, _b, _c;
  return React.createElement(BaseFormField, {
    ...props,
    label: (_c = (_a = props.label) !== null && _a !== void 0 ? _a : LABELS[(_b = props.funnel) !== null && _b !== void 0 ? _b : '']) !== null && _c !== void 0 ? _c : LABELS.ARHI
  }, React.createElement(Textbox, null));
};
const AccountNameWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AccountName, {
  ...props,
  maxLength: 32
}));
AccountName.defaultProps = defaultFieldPropTypes;
export default AccountNameWithFunnel;